import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getDashboardData } from "./../../modules/dashboard";
import * as DashboardTiles from "./DashboardTiles";
import DashboardConfiguration from "./DashboardConfiguration";
import Grid from "material-ui/Grid";
import LinearLoader from "./../../components/LinearLoader/LinearLoader";
import "./Dashboard.css";
import "./Dashboard.dark.css";
import RefreshIcon from "material-ui-icons/Refresh";
import TuneIcon from "material-ui-icons/Tune";
import { Button } from "material-ui";
import DownloadAs from "./../../components/DownloadAs/DownloadAs";
import { DOMAIN } from "./../../utilities/consts";

export const APAGADOS_MOTOR_TILE = "ApagadosMotorTile";
export const UNITS_STATUS_CHART_TILE = "UnitsStatusChartTile";
export const RALENTI_TILE = "RalentiTile";
export const EVENTOS_FUEL_TILE = "EventosFuelTile";
export const ORDEN_TRABAJO_TILE = "OrdenTrabajoTile";
export const REMINDER_TILE = "ReminderTile";
export const EVENTOS_DRIVING_TILE = "EventosDrivingTile";
export const GENERAL_CHARTS_TILE = "GeneralChartsTile";
export const COMPARATIVE_CHARTS_TILE = "ComparativeChartsTile";
export const UNITS_STATUS_TILE = "UnitsStatusTile";
export const MOVING_UNITS_CHART_TILE = "MovingUnitsChartTile";
export const MOVING_UNITS_TILE = "MovingUnitsTile";
export const IGNITION_STATUS_TILE = "IgnitionStatusTile";
export const IGNITION_STATUS_CHART_TILE = "IgnitionStatusChartTile";
export const SPEEDINGS_CHART_TILE = "SpeedingsChartTile";
export const WORK_ORDERS_TILE = "WorkOrdersTile";
export const FUEL_CONSUMPTION_ESTIMATE_TILE = "FuelConsumptionEstimateTile";
export const FUEL_CONSUMPTION_CHART_TILE = "FuelConsumptionChartTile";

const MINUTO = 60000;

let data = [
  {
    Tipo: FUEL_CONSUMPTION_ESTIMATE_TILE,
    Ancho: 1,
    Alto: 1
  },
  {
    Tipo: MOVING_UNITS_TILE,
    Ancho: 1,
    Alto: 1
  },
  {
    Tipo: UNITS_STATUS_CHART_TILE,
    Ancho: 1,
    Alto: 1
  },
  {
    Tipo: SPEEDINGS_CHART_TILE,
    Ancho: 1,
    Alto: 1
  },
  {
    Tipo: WORK_ORDERS_TILE,
    Ancho: 1,
    Alto: 1
  },
  {
    Tipo: COMPARATIVE_CHARTS_TILE,
    Ancho: 2,
    Alto: 2
  },
  {
    Tipo: REMINDER_TILE,
    Ancho: 1,
    Alto: 1
  },
  {
    Tipo: GENERAL_CHARTS_TILE,
    Ancho: 3,
    Alto: 2
  },
  {
    Tipo: IGNITION_STATUS_TILE,
    Ancho: 1,
    Alto: 1
  }
];

class DashboardView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      generalChartsUpdate: true,
      generalChartsStates: {
        isActiveIdle: true,
        isActiveWorkTime: false,
        isActiveDistanceTraveled: false,
        isActiveDeadTime: false
      },
      isConfigurationOpen: false
    };

    this.updateInterval = setInterval(this.updateChartsStates, 10000);
  }

  componentDidMount = () => {
    const hasData = this.props.hasData;
    console.log(hasData);
    this.props.getDashboardData({ zona: this.props.zone, tieneInfo: hasData });
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.configuration !== this.props.configuration) {
      if (this.props.configuration.IntervaloActualizacion > 0) {
        console.log("init interval");
        this.refreshDataInterval = setInterval(
          this.fetchDashboardData,
          this.props.configuration.IntervaloActualizacion * MINUTO
        );
      } else {
        clearInterval(this.refreshDataInterval);
      }
    }
  };

  componentWillUnmount = () => {
    clearInterval(this.updateInterval);
    clearInterval(this.refreshDataInterval);
  };

  updateChartsStates = () => {
    let generalChartStates = { ...this.state.generalChartsStates };
    let generalChartsUpdate = this.state.generalChartsUpdate;

    if (!generalChartsUpdate) return;

    if (generalChartStates.isActiveIdle)
      this.setState({
        generalChartsStates: {
          isActiveIdle: false,
          isActiveWorkTime: true,
          isActiveDistanceTraveled: false,
          isActiveDeadTime: false
        }
      });
    else if (generalChartStates.isActiveWorkTime)
      this.setState({
        generalChartsStates: {
          isActiveIdle: false,
          isActiveWorkTime: false,
          isActiveDistanceTraveled: true,
          isActiveDeadTime: false
        }
      });
    else if (generalChartStates.isActiveDistanceTraveled)
      this.setState({
        generalChartsStates: {
          isActiveIdle: false,
          isActiveWorkTime: false,
          isActiveDistanceTraveled: false,
          isActiveDeadTime: true
        }
      });
    else if (generalChartStates.isActiveDeadTime)
      this.setState({
        generalChartsStates: {
          isActiveIdle: true,
          isActiveWorkTime: false,
          isActiveDistanceTraveled: false,
          isActiveDeadTime: false
        }
      });
  };

  handleGeneralChartsBullets = selected => {
    switch (selected) {
      case "idle-chart":
        this.setState({
          generalChartsStates: {
            isActiveIdle: true,
            isActiveWorkTime: false,
            isActiveDistanceTraveled: false,
            isActiveDeadTime: false
          }
        });
        break;
      case "work-time-chart":
        this.setState({
          generalChartsStates: {
            isActiveIdle: false,
            isActiveWorkTime: true,
            isActiveDistanceTraveled: false,
            isActiveDeadTime: false
          }
        });
        break;
      case "distance-traveled-chart":
        this.setState({
          generalChartsStates: {
            isActiveIdle: false,
            isActiveWorkTime: false,
            isActiveDistanceTraveled: true,
            isActiveDeadTime: false
          }
        });
        break;
      case "dead-time-chart":
        this.setState({
          generalChartsStates: {
            isActiveIdle: false,
            isActiveWorkTime: false,
            isActiveDistanceTraveled: false,
            isActiveDeadTime: true
          }
        });
        break;
      default:
        break;
    }
  };

  handleOnMouseEnterGeneralCharts = () => {
    this.setState({ generalChartsUpdate: false });
  };

  handleOnMouseLeaveGeneralCharts = () => {
    this.setState({ generalChartsUpdate: true });
  };

  getDashboardTile = name => {
    const { lang, data } = this.props;
    switch (name) {
      case APAGADOS_MOTOR_TILE:
        return (
          <DashboardTiles.ApagadoMotorTile data={this.props.data} lang={lang} />
        );
      case UNITS_STATUS_CHART_TILE:
        return (
          <DashboardTiles.UnitsStatusChartTile
            data={this.props.data}
            lang={lang}
          />
        );
      case RALENTI_TILE:
        return (
          <DashboardTiles.RalentiTile data={this.props.data} lang={lang} />
        );
      case EVENTOS_FUEL_TILE:
        return (
          <DashboardTiles.EventosFuelTile data={this.props.data} lang={lang} />
        );
      case ORDEN_TRABAJO_TILE:
        return (
          <DashboardTiles.OrdenTrabajoTile data={this.props.data} lang={lang} />
        );
      case MOVING_UNITS_CHART_TILE:
        return (
          <DashboardTiles.MovingUnitsChartTile
            data={this.props.data}
            lang={lang}
          />
        );
      case REMINDER_TILE:
        return (
          <DashboardTiles.ReminderTile data={this.props.data} lang={lang} />
        );
      case EVENTOS_DRIVING_TILE:
        return (
          <DashboardTiles.EventosDrivingTile
            data={this.props.data}
            lang={lang}
          />
        );
      case FUEL_CONSUMPTION_ESTIMATE_TILE:
        return (
          <DashboardTiles.FuelConsumptionEstimateTile
            data={this.props.data}
            lang={lang}
          />
        );
      case FUEL_CONSUMPTION_CHART_TILE:
        return (
          <DashboardTiles.FuelConsumptionChartTile
            data={this.props.data}
            units={this.props.units}
            lang={lang}
          />
        );
      case GENERAL_CHARTS_TILE:
        return (
          <DashboardTiles.GeneralChartsTile
            data={this.props.data}
            units={this.props.units}
            lang={lang}
            onClickBullet={this.handleGeneralChartsBullets}
            onMouseEnter={this.handleOnMouseEnterGeneralCharts}
            onMouseLeave={this.handleOnMouseLeaveGeneralCharts}
            {...this.state.generalChartsStates}
          />
        );
      case COMPARATIVE_CHARTS_TILE:
        return (
          <DashboardTiles.ComparativeChartsTile
            lang={lang}
            data={this.props.data}
          />
        );
      case UNITS_STATUS_TILE:
        return (
          <DashboardTiles.UnitsStatusTile data={this.props.data} lang={lang} />
        );
      case MOVING_UNITS_TILE:
        return (
          <DashboardTiles.MovingUnitsTile data={this.props.data} lang={lang} />
        );
      case IGNITION_STATUS_TILE:
        return (
          <DashboardTiles.IgnitionStatusTile
            data={this.props.data}
            lang={lang}
          />
        );
      case IGNITION_STATUS_CHART_TILE:
        return (
          <DashboardTiles.IgnitionStatusChartTile
            data={this.props.data}
            lang={lang}
          />
        );
      case SPEEDINGS_CHART_TILE:
        return (
          <DashboardTiles.SpeedingsChartTile
            data={this.props.data}
            units={this.props.units}
            lang={lang}
          />
        );
      case WORK_ORDERS_TILE:
        return (
          <DashboardTiles.WorkOrdersTile data={this.props.data} lang={lang} />
        );
      default:
        return <div className="dashboard-tile">name</div>;
    }
  };

  createGrid = () => {
    const { configuration } = this.props;
    if (configuration) {
      for (let j = 0; j < configuration.Tarjetas.length; j++) {
        data[j].Tipo = configuration.Tarjetas[j];
      }
    }

    let i = 0;
    return data.map(d => (
      <Grid
        key={i++}
        item
        xs={12}
        sm={d.Ancho > 1 ? 12 : 6}
        md={4 * d.Ancho}
        lg={3 * d.Ancho}
        xl={3 * d.Ancho}
      >
        {/* <Paper className="rounded">{this.getDashboardTile(d.Tipo, {})}</Paper> */}
        {this.getDashboardTile(d.Tipo, {})}
      </Grid>
    ));
  };

  handleCloseConfiguration = () => {
    this.setState({ isConfigurationOpen: false });
  };

  openDashboarbConfiguration = () => {
    this.setState({ isConfigurationOpen: true });
  };

  fetchDashboardData = () => {
    console.log("fetch data");
    if (this.props.isLoading === false) {
      const hasData = this.props.hasData;
      console.log(hasData);

      this.props.getDashboardData({
        zona: this.props.zone,
        tieneInfo: hasData
      });
    }
  };

  downloadXls = () => {
    window.open(
      `${DOMAIN}/zeekAppsWS.asmx/DescargarReporteDashboard`,
      "_blank"
    );
    // const config = {
    //   configuracion: this.props.data
    // };
    // console.log(config);
    // if (this.props.hasData) {
    //   fetch(`${DOMAIN}/zeekAppsWS.asmx/DescargarReporteDashboard`, {
    //     method: "POST",
    //     body: JSON.stringify(config),
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type":
    //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    //     },
    //     credentials: "include"
    //   })
    //     .then(resp => {
    //       const blb = resp.blob();
    //       console.log(blb);
    //       return blb;
    //     })
    //     .then(blob => URL.createObjectURL(blob))
    //     .then(url => {
    //       console.log(url);

    //       window.location.assign(url);
    //     });

    // .then(resp => {
    //   const reader = resp.body.getReader();
    //   reader.read();
    //   console.log("descargar");
    //   return new ReadableStream({
    //     start(controller) {
    //       return pump();
    //       function pump() {
    //         return reader.read().then(({ done, value }) => {
    //           // When no more data needs to be consumed, close the stream
    //           if (done) {
    //             controller.close();
    //             return;
    //           }
    //           // Enqueue the next data chunk into our target stream
    //           controller.enqueue(value);
    //           return pump();
    //         });
    //       }
    //     }
    //   });
    // })
    // .then(stream => new Response(stream))
    // .then(response => response.blob())
    // .then(blob => URL.createObjectURL(blob))
    // .then(url => {
    //   console.log(url);
    //   window.open(url);
    // })
    // .catch(err => console.error(err));
    //}
  };

  render() {
    return (
      <div className="dashboard">
        {this.props.isLoading && <LinearLoader />}
        <div className="dashboard-bar">
          <div
            style={{ float: "right", marginRight: "2rem", marginTop: "0.5rem" }}
          >
            <span className="bar-label">
              {this.props.lang.RangoDeConsulta}:{" "}
              {this.props.configuration.RangoConsulta} hrs.
            </span>
            <span className="bar-label">
              {this.props.configuration.IntervaloActualizacion > 0
                ? `${this.props.lang.IntervaloDeActualizacion}: ${
                    this.props.configuration.IntervaloActualizacion
                  } min.`
                : this.props.lang.ActualizacionManual}
            </span>
            {this.props.configuration.IntervaloActualizacion == 0 && (
              <Button
                color="primary"
                onClick={this.fetchDashboardData}
                variant="raised"
                size="small"
                style={{
                  marginLeft: "1rem"
                }}
              >
                <RefreshIcon size="small" style={{ color: "#FFF" }} />
              </Button>
            )}

            <Button
              onClick={this.openDashboarbConfiguration}
              color="primary"
              variant="raised"
              size="small"
              style={{ marginLeft: "0.5rem", marginRight: "0.5rem" }}
            >
              <TuneIcon style={{ color: "#FFF", marginRight: "0.6rem" }} />
              {this.props.lang.Ajustes}
            </Button>
            <DownloadAs
              style={{ marginLeft: "0.5rem" }}
              text={this.props.lang}
              size="small"
              xls={true}
              xlsClick={this.downloadXls}
            />
          </div>
        </div>
        {this.props.hasData && (
          <div className="root">
            <Grid container>{this.createGrid()}</Grid>
          </div>
        )}

        {this.props.hasDataConfiguration && (
          <DashboardConfiguration
            lang={this.props.lang}
            isConfigurationOpen={this.state.isConfigurationOpen}
            onCloseConfiguration={this.handleCloseConfiguration}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    lang: state.internationalization.lang,
    configuration: state.dashboard.configuration,
    data: state.dashboard.data,
    hasData: state.dashboard.hasData,
    hasDataConfiguration: state.dashboard.hasDataConfiguration,
    zone: state.dates.zone,
    units: state.units.data,
    isLoading: state.dashboard.isLoading
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ getDashboardData }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardView);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardView.js